<template>
  <Section
    @back="$emit('back')"
    title="配信地点グループ・配信対象者"
    margin
    tip-message="地点設定に戻る"
  >
    <v-subheader>配信地点グループ・半径</v-subheader>
    <v-flex v-if="hasSimulationLocationGroup">
      <p class="caption grey--text pl-3">
        配信地点グループに設定した地点グループのうち、
        シミュレーションから読み込まれたグループ （<v-icon
          class="simulation-point-icon"
          >fiber_manual_record </v-icon
        >） は、新規で案件用の地点グループとして保存されます。
      </p>
    </v-flex>
    <v-layout
      v-for="group in menuSetting.visibleDeliveryLocationGroups"
      :key="group.locationGroupId"
      pl-4
    >
      <v-flex :class="['groupName', { isSimulation: group.isSimulation }]" xs3>
        {{ locationGroupName(group) }}
      </v-flex>
      <v-flex :class="{ disabled: menuSetting.enableRadiusAutomation }" xs9>
        {{ displayLocationGroupRadius(group) }}
      </v-flex>
    </v-layout>
    <CampaignModalPageConfirmTarget :menuSetting="menuSetting" />
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection.vue'
import CampaignModalPageConfirmTarget from './CampaignModalPageConfirmTarget.vue'
export default {
  name: 'CampaignModalPageConfirmGeoTarget',
  components: {
    Section,
    CampaignModalPageConfirmTarget,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
    hasSimulationLocationGroup() {
      return this.menuSetting.visibleDeliveryLocationGroups.some(
        group => group.isSimulation === true,
      )
    },
  },
  methods: {
    displayLocationGroupRadius(group) {
      if (this.menuSetting.enableRadiusAutomation) {
        return '半径自動最適化'
      } else if (this.menuSetting.enableBulkSetting) {
        return `${this.menuSetting.radius.toLocaleString()}m`
      } else {
        return `${group.radius.toLocaleString()}m`
      }
    },
    locationGroupName(deliveryLocationGroup) {
      const locationGroup = this.menuSetting.findLocationGroup(
        deliveryLocationGroup.locationGroupId,
      )
      return locationGroup ? locationGroup.name : '----'
    },
  },
}
</script>

<style scoped>
.disabled {
  color: rgba(0, 0, 0, 0.4);
}
.groupName:not(.isSimulation) {
  padding-left: 16px;
}
.isSimulation::before {
  font-family: 'Material Icons';
  content: '\e061';
  color: #0baaf6;
  font-size: 15px;
  padding-right: 2px;
  display: block;
  float: left;
}
.simulation-point-icon {
  font-size: 14px;
  color: #0baaf6;
}
</style>
